import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Select, MenuItem } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import ThemeButton from 'ui-component/ThemeButton';
import { useTranslation } from 'react-i18next';

// assets
import { IconMenu2 } from '@tabler/icons-react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {const { t, i18n } = useTranslation();
  
  const theme = useTheme();
  // 下拉框必须反映真实语言，避免与 i18n.language 脱钩导致"点了不切换"
  const currentLang = (i18n.resolvedLanguage || i18n.language || 'zh').split('-')[0];

  const languageOptions = [
    { key: 'zh', text: t("中文"), value: 'zh' },
    { key: 'en', text: 'English', value: 'en' },
  ];

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handleToIndex = () => {
    window.open(window.location.href , '_blank');
  };

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(window.location.href, '_blank');
  }}>
          <LogoSection />
        </Box>
        {/* <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              ...theme.typography.menuButton,
              transition: 'all .2s ease-in-out',
              '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase> */}
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      {/* <ThemeButton /> */}
      <Select
        id="language-type-label"
        value={currentLang}
        name="type"
        onChange={(e) => changeLanguage(e.target.value)}
        sx={{maxHeight: '40px'}}
      >
        {
          languageOptions.map((option) => {             return (
              <MenuItem key={option.key} value={option.value}>
                {option.text}
              </MenuItem>
            );
          })}
      </Select>
      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
